import operationTypes from 'constants/operationTypes';

import { titleColumn } from '../constants/partnerBookConstants';

type GetFilterValueProps = {
  partnerIndex: number;
  index: number;
  data: string | number | null | undefined;
  column: string;
  isForScreen: boolean;
  bookPartnersArray: (string | number)[][];
  bookOperations: Record<string, string>;
};

const formatNumberForScreen = (value: number): string =>
  value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

export const getFilterValue = ({
  partnerIndex,
  index,
  data,
  column,
  isForScreen,
  bookPartnersArray,
  bookOperations,
}: GetFilterValueProps): string | number => {
  const condition1 =
    bookOperations[index - 2] === operationTypes.SELL_PARTICIPATION ||
    bookOperations[index - 2] === operationTypes.HERITAGE ||
    bookOperations[index - 2] === operationTypes.DONATION ||
    bookOperations[index - 2] === operationTypes.ENDORSEMENT ||
    bookOperations[index - 2] === operationTypes.TRANSMISSION;

  const condition2 =
    bookOperations[index - 3] === operationTypes.SELL_PARTICIPATION ||
    bookOperations[index - 3] === operationTypes.HERITAGE ||
    bookOperations[index - 3] === operationTypes.DONATION ||
    bookOperations[index - 3] === operationTypes.ENDORSEMENT ||
    bookOperations[index - 3] === operationTypes.TRANSMISSION;

  if (data && column === titleColumn.PARTNERS) {
    return data.toString();
  }

  if (data !== 0 && column === titleColumn.PERCENT) {
    if (data === null || data === undefined) return '';

    const numericValue = Number(data);
    if (Number.isNaN(numericValue)) return '';

    return isForScreen
      ? `${numericValue.toFixed(2)}%`
      : parseFloat(numericValue.toFixed(2));
  }

  if (data !== 0 && column !== titleColumn.PERCENT) {
    if (data === null || data === undefined) return '';

    const numericValue = Number(data);
    if (Number.isNaN(numericValue)) return '';

    return isForScreen ? formatNumberForScreen(numericValue) : numericValue;
  }

  if (column === titleColumn.TOTAL) {
    if (
      bookOperations[index - 1] === operationTypes.CAPITAL_DECREASE &&
      bookPartnersArray[partnerIndex]?.[index - 1]
    ) {
      return 0;
    }
    if (condition1 && bookPartnersArray[partnerIndex]?.[index - 1]) {
      return 0;
    }
  }

  if (column === titleColumn.PERCENT) {
    if (
      bookOperations[index - 2] === operationTypes.CAPITAL_DECREASE &&
      bookPartnersArray[partnerIndex]?.[index - 2]
    ) {
      return isForScreen ? '0.00%' : 0.0;
    }
    if (condition2 && bookPartnersArray[partnerIndex]?.[index - 2]) {
      return isForScreen ? '0.00%' : 0.0;
    }
  }

  return '';
};
